import { useMutation } from "@tanstack/react-query";
import axios from "axios";

interface FeedbackPayload {
    baseUrl: string;
    agent_id: string;
    tenant_id: string;
    workspace_id: string;
    call_id: string;
    feedback_category: string;
    issue_severity: string;
    issue_description: string;
    expected_behavior: string;
    user_name: string;
}

export const postUatFeedback = async (data: FeedbackPayload) => {
    const response = await axios.post(
        `${data.baseUrl}/uat/feedback`,
        {
            agent_id: data.agent_id,
            call_id: data.call_id,
            feedback_category: data.feedback_category,
            issue_severity: data.issue_severity,
            issue_description: data.issue_description,
            expected_behavior: data.expected_behavior,
            ...(data.user_name?.trim() ? { user_name: data.user_name } : {})
        },
        {
            headers: {
                "Content-Type": "application/json",
                "tenant-id": data.tenant_id.toString(),
                "workspace-id": data.workspace_id.toString()
            }
        }
    );

    return response.data;
};

export const useUatFeedbackMutation = () => {
    return useMutation({
        mutationFn: postUatFeedback
    });
};
